import React, { useState, useEffect, useCallback } from 'react';
import { servicesAPI } from '../utils/api';
import ServiceCard from '../components/services/ServiceCard';
import './ListingPage.css';

const CATEGORIES = [
  { value: '', label: 'كل الخدمات' },
  { value: 'tournament_management', label: 'إدارة بطولات' },
  { value: 'refereeing', label: 'تحكيم' },
  { value: 'photography', label: 'تصوير' },
  { value: 'design', label: 'تصميم' },
  { value: 'live_streaming', label: 'بث مباشر' },
  { value: 'private_coaching', label: 'تدريب خاص' },
  { value: 'sports_consulting', label: 'استشارات رياضية' },
  { value: 'event_operations', label: 'تشغيل فعاليات' },
  { value: 'video_analysis', label: 'تحليل فيديو' },
  { value: 'fitness_training', label: 'تدريب لياقة' },
  { value: 'nutrition', label: 'تغذية رياضية' },
  { value: 'other', label: 'أخرى' },
];

const ServicesPage = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(1);
  const [filters, setFilters] = useState({ search: '', category: '', sort: 'popular', page: 1 });

  const fetchServices = useCallback(async () => {
    setLoading(true);
    try {
      const params = Object.fromEntries(Object.entries(filters).filter(([_, v]) => v !== ''));
      const res = await servicesAPI.getServices(params);
      setServices(res.data.services || []);
      setTotal(res.data.total || 0);
      setPages(res.data.pages || 1);
    } catch (e) {} finally { setLoading(false); }
  }, [filters]);

  useEffect(() => { fetchServices(); }, [fetchServices]);

  const handleFilter = (key, val) => setFilters(p => ({ ...p, [key]: val, page: 1 }));

  return (
    <div className="page-wrapper">
      <div className="container">
        <div className="page-header">
          <h1>الخدمات الرياضية</h1>
          <p>استعن بأفضل المحترفين الرياضيين لمشاريعك وفعالياتك</p>
        </div>

        <div className="filter-bar">
          <div className="form-group">
            <label className="form-label">بحث</label>
            <input type="text" className="form-input" placeholder="ابحث عن خدمة..." value={filters.search} onChange={e => handleFilter('search', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">التصنيف</label>
            <select className="form-select" value={filters.category} onChange={e => handleFilter('category', e.target.value)}>
              {CATEGORIES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">الترتيب</label>
            <select className="form-select" value={filters.sort} onChange={e => handleFilter('sort', e.target.value)}>
              <option value="popular">الأكثر طلباً</option>
              <option value="newest">الأحدث</option>
              <option value="rating">الأعلى تقييماً</option>
              <option value="price_low">السعر: الأقل</option>
              <option value="price_high">السعر: الأعلى</option>
            </select>
          </div>
        </div>

        {loading ? (
          <div className="loading-screen"><div className="spinner" /></div>
        ) : services.length === 0 ? (
          <div className="empty-state"><div className="icon">⚡</div><h3>لا توجد خدمات</h3></div>
        ) : (
          <>
            <div className="results-count">{total} خدمة</div>
            <div className="grid-3">{services.map(s => <ServiceCard key={s.uuid} service={s} />)}</div>
            {pages > 1 && (
              <div className="pagination">
                <button className="page-btn" onClick={() => handleFilter('page', Math.max(1, filters.page - 1))} disabled={filters.page === 1}>‹</button>
                {Array.from({ length: Math.min(5, pages) }, (_, i) => i + 1).map(p => (
                  <button key={p} className={`page-btn ${filters.page === p ? 'active' : ''}`} onClick={() => handleFilter('page', p)}>{p}</button>
                ))}
                <button className="page-btn" onClick={() => handleFilter('page', Math.min(pages, filters.page + 1))} disabled={filters.page === pages}>›</button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ServicesPage;
